import type { EventType } from 'models';
import { useMemo } from 'react';
import { images } from 'common/utils';
import { useGetMediaSource } from 'features/media';

type P = {
  coverPhoto?: string;
  type: EventType;
};

export const useGetEventCoverPhoto = ({ coverPhoto, type }: P) => {
  const getMediaSource = useGetMediaSource();

  return useMemo(() => {
    if (coverPhoto) {
      return getMediaSource({ id: coverPhoto });
    }

    switch (type) {
      case 'call':
      case 'clinical_review':
      case 'telehealth_visit':
      case 'video_conference':
      case 'webinar':
        return images.default.eventCoverPhoto;
      case 'reminder':
        return images.default.reminderCoverPhoto;
    }
  }, [coverPhoto, getMediaSource, type]);
};
